import React from 'react';

import logo from '../../images/rediseg-login.png';
import logo2x from '../../images/rediseg-login@2x.png';
import RetinaImage from 'react-retina-image';
import ProgressBar from '../ProgressBar';

import { Field, reduxForm } from 'redux-form';

const Card = ({ handleSubmit, submitting, pristine }) => {
  return (
    <div className="card-login mdl-card mdl-shadow--2dp">
      <div className="m-4">
        <div className="mt-4">
          <RetinaImage className="header-logo" src={[logo, logo2x]} />
          <form className="mt-4" onSubmit={ handleSubmit }>
            <div className="form-group">
              <Field component="input" type="text" className="form-control" placeholder="Nome" name="nome" />
            </div>

            <div className={`form-group`}>
              <Field component="input" type="email" className="form-control" placeholder="E-mail" name="email" />
            </div>

            <div className="form-group">
              <Field component="input" type="phone" className="form-control" placeholder="Telefone" name="telefone" />
            </div>

            <button type="submit"
                className="sign-in-btn mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent"
                disabled={ submitting || pristine }>
              { submitting ? 'aguarde...' : 'Entrar' }
            </button>
            <ProgressBar style={{ display: submitting ? 'block' : 'none' }} />
          </form>
        </div>
      </div>
    </div>
  );
};

export default reduxForm({form: 'completar-cadastro'})(Card);



// WEBPACK FOOTER //
// ./src/components/login/CardCompletarCadastro.js